// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.11@core-js/library/modules/_defined.js
// module id = 43
// module chunks = 0